import React, { useEffect, useRef } from "react";

const CountryMarquee = ({countrieslist, onActiveChange}) => {
  const marqueeRef = useRef(null);
  const trackRef = useRef(null);
  const animationFrameRef = useRef(null);

  // Use a ref to hold mutable state used inside requestAnimationFrame
  const stateRef = useRef({
    offset: 0,
    lastTime: null,
    paused: false,
    clickedPause: false,
    currentActive: null,
    items: [],
  });

  useEffect(() => {
    const marquee = marqueeRef.current;
    const track = trackRef.current;
    if (!marquee || !track) return;

    // Clone the original items into the track (same as your JS)
    const originalItems = Array.from(track.children);
    originalItems.forEach((el) => track.appendChild(el.cloneNode(true)));

    const items = Array.from(track.children);
    stateRef.current.items = items;

    const speed = 40;
    // const setActive = (el) => {
    // const { items } = stateRef.current;
    // items.forEach((i) => i.classList.remove("active"));

    //   if (el) {
    //     el.classList.add("active");

    //     // 🔥 Send active element's text to Landing
    //     if (typeof onActiveChange === "function") {
    //       onActiveChange(el.textContent.trim());
    //     }
    //   }
    //   stateRef.current.currentActive = el;
    // };

    // Auto active first item
    // setActive(items[0]);

    // CLICK logic
    // const clickHandler = (item) => () => {
    //   const { currentActive, clickedPause } = stateRef.current;

    //   if (currentActive === item && clickedPause) {
    //     stateRef.current.clickedPause = false;
    //     stateRef.current.paused = false;
    //   } else {
    //     // activate + pause
    //     // setActive(item);
    //     stateRef.current.clickedPause = true;
    //     stateRef.current.paused = true;
    //   }
    // };

    // items.forEach((item) => {
    //   item.addEventListener("click", clickHandler(item));
    //   // Store handler on element so we can remove it on cleanup
    //   item._clickHandler = clickHandler(item);
    // });

    // HOVER logic
    const onMouseEnter = () => {
      stateRef.current.paused = true;
    };

    const onMouseLeave = () => {
      stateRef.current.paused = false;
      stateRef.current.clickedPause = false; // allow scrolling to move again
    };

    marquee.addEventListener("mouseenter", onMouseEnter);
    marquee.addEventListener("mouseleave", onMouseLeave);

    const step = (timestamp) => {
      const state = stateRef.current;

      if (!state.lastTime) state.lastTime = timestamp;
      let dt = (timestamp - state.lastTime) / 1000;
      if (dt > 0.05) dt = 0.05;
      state.lastTime = timestamp;

      if (!state.paused) {
        state.offset -= speed * dt;
        track.style.transform = `translate3d(${state.offset}px,0,0)`;
      }

      const marqueeRect = marquee.getBoundingClientRect();
      const leftEdge = marqueeRect.left;
      const triggerX = leftEdge + 40; // only highlight when item is fully visible

      let items = state.items;
      let first = items[0];
      let firstRect = first.getBoundingClientRect();

      // Recycle first item to the end when completely out of view
      if (firstRect.right <= leftEdge) {
        const marginRight =
          parseFloat(getComputedStyle(first).marginRight) || 0;
        const width = first.offsetWidth + marginRight;

        state.offset += width;
        track.style.transform = `translate3d(${state.offset}px,0,0)`;

        track.appendChild(first);
        items.push(items.shift());
        state.items = items; // update reference
      }

      // Auto active only when user hasn't manually clicked
      // if (!state.clickedPause) {
      //   let newActive = null;
      //   items.forEach((item) => {
      //     const rect = item.getBoundingClientRect();
      //     if (rect.left <= triggerX && rect.right > triggerX) {
      //       newActive = item;
      //     }
      //     if (state.currentActive === item && rect.right <= leftEdge) {
      //       setActive(null);
      //     }
      //   });

      //   if (newActive && newActive !== state.currentActive) {
      //     setActive(newActive);
      //   }
      // }

      animationFrameRef.current = requestAnimationFrame(step);
    };

    animationFrameRef.current = requestAnimationFrame(step);

    // Cleanup
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      marquee.removeEventListener("mouseenter", onMouseEnter);
      marquee.removeEventListener("mouseleave", onMouseLeave);
      items.forEach((item) => {
        // if (item._clickHandler) {
        //   item.removeEventListener("click", item._clickHandler);
        //   delete item._clickHandler;
        // }
      });
    };
  }, []);

  return (

      <div className="marquee" ref={marqueeRef}>
        <div className="track" ref={trackRef}>
            {countrieslist?.map((country) => (
          <div className="country" data-country="IN">
            {country}
          </div>
          ))}
        </div>
      </div>
  );
};

export default CountryMarquee;